import { MantineProvider } from '@mantine/core';
import { ReactNode } from 'react';

/**
 * Mantine v7 components throw when rendered outside a MantineProvider.
 * Only @mantine/dates is used (no theming), so the provider is scoped to the Jxt pickers
 * rather than wrapping every app. The Mantine stylesheets are loaded in the `vendor` layer
 * by `@jooxter/tailwind-config`, so Tailwind utilities always win over them.
 */
const JxtMantineProvider = ({ children }: { children: ReactNode }) => (
  <MantineProvider forceColorScheme="light">{children}</MantineProvider>
);

export default JxtMantineProvider;
